declare const monthDay: unique symbol;

export type MonthDay = number & { [monthDay]: 'MonthDay' };

export const isMonthDay = (n: number): n is MonthDay =>
  Number.isInteger(n) && n >= 1 && n <= 31;
